import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { AlertCircle } from "lucide-react";
import Message from "../../../../../i18n/Message";
import "./RequestChart.scss";

const RequestChart = ({ data, interval, error }) => {
  const chartData =
    data?.points?.map((p) => ({
      name: formatTimestamp(p.timestamp, interval),
      count: p.count,
      avgDuration: p.avgDurationMs,
    })) || [];

  const renderContent = () => {
    if (error) {
      return (
        <div className="chart_error">
          <AlertCircle size={24} />
          <span>Failed to load chart data</span>
        </div>
      );
    }

    if (chartData.length > 0) {
      return (
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 11, fill: "#6b7280" }}
              axisLine={{ stroke: "#e5e7eb" }}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 11, fill: "#6b7280" }}
              axisLine={{ stroke: "#e5e7eb" }}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              }}
            />
            <Bar
              dataKey="count"
              fill="#6366f1"
              radius={[4, 4, 0, 0]}
              maxBarSize={36}
              name="Requests"
            />
          </BarChart>
        </ResponsiveContainer>
      );
    }

    return <div className="no_data">No data available for this period</div>;
  };

  return (
    <div className="request_chart card">
      <div className="chart_header">
        <h4>
          <Message id="request_volume" />
        </h4>
        {interval && (
          <span className="interval_label">
            {interval === "hourly" ? "Hourly" : "Daily"}
          </span>
        )}
      </div>
      <div className="chart_container">{renderContent()}</div>
    </div>
  );
};

const formatTimestamp = (timestamp, interval) => {
  const date = new Date(timestamp);
  if (interval === "hourly") {
    // Include date to make names unique across multiple days
    const day = date.toLocaleDateString([], { month: "short", day: "numeric" });
    const time = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    return `${day} ${time}`;
  }
  return date.toLocaleDateString([], { month: "short", day: "numeric" });
};

export default RequestChart;
